// extracted by mini-css-extract-plugin
export default {"globe":"peacegame_LogoSpinning_globe","centered":"peacegame_LogoSpinning_centered"};